import React from 'react'
import {
  Box,
  Button,
  Grid,
} from '@material-ui/core'


import { Batch } from 'src/api/models'
import {
  MoveHandler,
  MoveItem,
} from 'src/scanRouter/handlers'

import { ProductCard } from '../ModelCard'

interface MoveItemDisplayProps {
  handler: MoveHandler
  item: MoveItem
}

export const MoveItemDisplay = (props: MoveItemDisplayProps) => {
  const { handler, item } = props
  const {batches, batch: selectedBatch} = item
  const selectBatch = handler.batchSelector(item)
  const handleSelectBatch = (batch: Batch) => {
      if (selectBatch && selectedBatch?.guid !== batch.guid) {
        selectBatch(selectedBatch, batch)
      }
  }
  return (
    <Grid key={item.key} item container spacing={2} alignItems="center">
      <Grid item xs={10}>
        <ProductCard
          item={item.product.object}
          sku={item.sku?.object}
          selectedCase={item.productCase}
          selectCase={handler.caseSelector(item)}
        >
          {!!batches &&
            <Grid item container spacing={6} xs={12}>
              <Grid item>
                <Box fontWeight="bold">Batch:</Box>
              </Grid>
              <Grid item>
                {batches?.map((batch: Batch) => (
                  <Button
                    key={batch.guid}
                    size="small"
                    variant={selectedBatch?.guid === batch.guid ? 'contained' : 'outlined'}
                    onClick={() => handleSelectBatch(batch)}
                  >
                    {batch.name}
                  </Button>
                ))}
              </Grid>
            </Grid>
          }
        </ProductCard>
      </Grid>
      <Grid item xs={2}>
        <Button variant="outlined">{!!item.count && <span>x{item.count}</span>}</Button>
      </Grid>
    </Grid>
  )
}
